export default {
    amount (v) {
        v = Number(v);
        if (v > 9999) {
            return v / 10000 + '万';
        }
        return v + '元';
    },
    httpTohttps (v) {
        if (v.indexOf('http://') === 0) {
            return v.replace(/^http:\/\//, 'https://');
        } else {
            return v;
        }
    }
};



// WEBPACK FOOTER //
// ./src/config/filter.js